import { Phone, Mail, MapPin, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-navy-900 text-gray-300 border-t border-gold-600/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex flex-col">
              <span className="text-2xl font-bold font-serif text-white tracking-wider">GLOBAL LINK</span>
              <span className="text-xs text-gold-400 tracking-widest">STRATEGY LIMITED</span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              {t('visionMission.visionDesc').substring(0, 100)}...
            </p>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-4 font-serif">{t('nav.services')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-gold-400 transition-colors">{t('services.ipo.title')}</Link></li>
              <li><Link to="/services" className="hover:text-gold-400 transition-colors">{t('services.ma.title')}</Link></li>
              <li><Link to="/services" className="hover:text-gold-400 transition-colors">{t('services.corpFin.title')}</Link></li>
              <li><Link to="/services" className="hover:text-gold-400 transition-colors">{t('services.corpStruct.title')}</Link></li>
              <li><Link to="/services" className="hover:text-gold-400 transition-colors">{t('services.opsMgmt.title')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-4 font-serif">{t('contact.title')}</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-gold-500 flex-shrink-0" />
                <span>{t('footer.address')}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-gold-500 flex-shrink-0" />
                <span>{t('footer.phone')}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-gold-500 flex-shrink-0" />
                <span>{t('footer.email')}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Globe className="h-5 w-5 text-gold-500 flex-shrink-0" />
                <span>{t('footer.website')}</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="mt-6">
              <ul className="space-y-2 text-xs text-gray-500">
                <li><a href="#" className="hover:text-gray-300">{t('footer.links.privacy')}</a></li>
                <li><a href="#" className="hover:text-gray-300">{t('footer.links.terms')}</a></li>
                <li><Link to="/admin" className="hover:text-gray-300">Admin Login</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-navy-800 mt-12 pt-8 text-center text-sm text-gray-500">
          <p>{t('footer.copyright')} | v1.2</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
